import UserCreate from './UserCreate';

export default UserCreate;


// WEBPACK FOOTER //
// ./resources/assets/js/components/UserCreate/index.js